// Star.js
import React from 'react'
import styled from '@emotion/styled'

const StarWrapper = styled.span`
  color: ${({ filled }) => (filled ? '#ffb400' : '#ccc')};
  font-size: ${({ size }) => size || '20px'};
  cursor: ${({ readOnly }) => (readOnly ? 'default' : 'pointer')};
  transition: transform 0.2s ease;
  outline: none;
  user-select: none;

  &:active {
    transform: ${({ readOnly }) => (readOnly ? 'none' : 'scale(1.25)')};
  }

  &:focus {
    outline: none;
  }
`

export function Star({ filled, readOnly, size, onClick, onKeyDown }) {
  return (
    <StarWrapper
      filled={filled}
      readOnly={readOnly}
      size={size}
      role={readOnly ? 'img' : 'button'}
      tabIndex={readOnly ? -1 : 0}
      onClick={readOnly ? undefined : onClick}
      onKeyDown={readOnly ? undefined : onKeyDown}
    >
      ★
    </StarWrapper>
  )
}
